/* eslint-disable @typescript-eslint/no-explicit-any */
/* eslint-disable @typescript-eslint/no-empty-function */

import { Component, Input, OnInit, Self } from '@angular/core';
import { ControlValueAccessor, NgControl } from '@angular/forms';

@Component({
  selector: 'app-ui-radio-button',
  styleUrls: ['./ui-radio-button.component.scss'],
  templateUrl: './ui-radio-button.component.html',
  standalone: false
})
export class UIRadioButtonComponent implements OnInit, ControlValueAccessor {
  @Input() value: string | number | boolean;
  @Input() tooltipText: string;

  model: string | number | boolean;
  disabled = false;

  onChange: any = () => {};
  onTouched: any = () => {};

  constructor(@Self() private ngControl: NgControl) {
    ngControl.valueAccessor = this;
  }

  ngOnInit() {
    this.ngControl.control.valueChanges.subscribe((value: string | number) => {
      // Check to ensure the value wasn't already set (Template driven forms)
      if (this.model === value) return;
      this.writeValue(value);
    });
  }

  writeValue(value: number | string): void {
    this.model = value;
  }

  registerOnChange(fn: any): void {
    this.onChange = fn;
  }

  registerOnTouched(fn: any): void {
    this.onTouched = fn;
  }

  setDisabledState(isDisabled: boolean): void {
    this.disabled = isDisabled;
  }

  select(): void {
    if (this.disabled) return;
    this.model = this.value;
    this.onChange(this.model);
  }
}
